import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AppIcon, AppIconName } from '../icons/icon.type';
import { IconsModule } from '../icons/icons.module';

@Component({
  selector: 'app-badge',
  template: `
    @if (icon) {
      <app-icon [icon]="icon"></app-icon>
    }
    <ng-content></ng-content>
  `,
  styleUrls: ['./styles/badge.scss'],
  imports: [IconsModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  @Input()
  icon?: AppIcon | AppIconName;
}
